import { boot } from 'quasar/wrappers'
import * as amplitude from '@amplitude/analytics-browser'

export default boot(({ app }) => {
  if (typeof process.env.AMPLITUDE_API_KEY === 'undefined') {
    app.config.globalProperties.$amplitude = null
  } else {
    amplitude.init(process.env.AMPLITUDE_API_KEY, {
      serverZone: 'EU',
      optOut: true,
      defaultTracking: false
    })
    app.config.globalProperties.$amplitude = amplitude
  }
})
